var map = {
	"./chitra.webp": 27483,
	"./dharanisri.webp": 87401,
	"./hemalatha.webp": 68822,
	"./jagadeesan.webp": 24957,
	"./kalpana.webp": 51598,
	"./karthikeyan.webp": 22819,
	"./kavitha.webp": 65080,
	"./pyingkodi.webp": 80084,
	"./rahunathan.webp": 24680,
	"./sindhu.webp": 55825,
	"./tamilarasi.webp": 52851,
	"./vijayakumar.webp": 95262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24652;